import React, { useState } from 'react';
import { Box, Button, Tooltip, CircularProgress } from '@mui/material';
import TableViewIcon from '@mui/icons-material/TableView';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {
  exportJornadaToExcel,
  exportJornadaToPDF,
  CompanyJourneyResponseDto,
  ClientJourneyDetail,
} from '../utils/jornadaExport';

interface JornadaExportButtonsProps {
  data: CompanyJourneyResponseDto | null;
  fetchClientDetail?: (id_loja: number) => Promise<ClientJourneyDetail | null>;
  fileNamePrefix?: string;
}

const JornadaExportButtons: React.FC<JornadaExportButtonsProps> = ({
  data,
  fetchClientDetail,
  fileNamePrefix = 'jornada_cliente',
}) => {
  const [exportingExcel, setExportingExcel] = useState(false);
  const [exportingPDF, setExportingPDF] = useState(false);

  const today = new Date().toISOString().split('T')[0];
  const fileName = `${fileNamePrefix}_${today}`;

  const handleExportExcel = async () => {
    if (!data) return;
    setExportingExcel(true);
    try {
      await exportJornadaToExcel(data, fetchClientDetail, fileName);
    } catch (err) {
      console.error('Erro ao exportar Excel:', err);
      alert('Ocorreu um erro ao gerar o arquivo Excel.');
    } finally {
      setExportingExcel(false);
    }
  };

  const handleExportPDF = async () => {
    if (!data) return;
    setExportingPDF(true);
    try {
      await exportJornadaToPDF(data, fetchClientDetail, fileName);
    } catch (err) {
      console.error('Erro ao exportar PDF:', err);
      alert('Ocorreu um erro ao gerar o arquivo PDF.');
    } finally {
      setExportingPDF(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
      <Tooltip title="Exportar relatório em Excel (.xlsx) com detalhamento completo por cliente e reuniões (RD, RE, RC, RI, RAE, RA, RP)">
        <span>
          <Button
            variant="contained"
            color="success"
            startIcon={
              exportingExcel ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                <TableViewIcon />
              )
            }
            onClick={handleExportExcel}
            disabled={!data || exportingExcel || exportingPDF}
            size="small"
            sx={{ fontWeight: 700, borderRadius: '8px', px: 2, py: 0.8 }}
          >
            {exportingExcel ? 'Gerando Excel...' : 'Exportar Excel'}
          </Button>
        </span>
      </Tooltip>

      <Tooltip title="Exportar relatório em PDF (.pdf) com detalhamento completo por cliente e reuniões (RD, RE, RC, RI, RAE, RA, RP)">
        <span>
          <Button
            variant="contained"
            color="error"
            startIcon={
              exportingPDF ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                <PictureAsPdfIcon />
              )
            }
            onClick={handleExportPDF}
            disabled={!data || exportingExcel || exportingPDF}
            size="small"
            sx={{ fontWeight: 700, borderRadius: '8px', px: 2, py: 0.8 }}
          >
            {exportingPDF ? 'Gerando PDF...' : 'Exportar PDF'}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default JornadaExportButtons;
